import React from 'react';

interface AccessibleDataTableProps {
    caption: string;
    headers: string[];
    rows: Array<Array<string | number>>;
}

const AccessibleDataTable: React.FC<AccessibleDataTableProps> = ({
    caption,
    headers,
    rows,
}) => (
    <div className="sr-only">
        <table>
            <caption>{caption}</caption>
            <thead>
                <tr>
                    {headers.map((header) => (
                        <th key={header} scope="col">
                            {header}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => (
                    <tr key={`${row.join('-')}-${rowIndex}`}>
                        {row.map((cell, cellIndex) =>
                            cellIndex === 0 ? (
                                <th key={cellIndex} scope="row">
                                    {cell}
                                </th>
                            ) : (
                                <td key={cellIndex}>{cell}</td>
                            )
                        )}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default AccessibleDataTable;
